import React from 'react';
const ErrorPage: React.FC = () => {


  return (
      <>
        <main className="main">
        <div className="container">
        
              <div className="row justify-content-center pb-5">
                <div className="col-lg-12 mt-5 ">
                   <div className="thank-you-div" >
                    <div className="text-center">
                      <img src={`assets/img/nofound.jpeg`} alt="img-fluid" className="img-fluid rounded-3" />
                      
                      </div>

                       
                    </div>
                </div>
                <div className="col-sm-12 text-center">!!! OOPS !!! </div>
                         <div className="col-sm-12 text-center">                 The  requested page  cannot be found or it may be some technical issue .</div>
                                       <div className="col-sm-12 text-center">          We apologize for the inconvenience..  .
                                </div>
             
          </div>
        </div>
   
    </main>
      </>
  );
};

export default ErrorPage;